import * as React from 'react';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import {
  IconButton,
  Card,
  RouteWrapper,
  HeadingSection,
  ServicingTable,
  Section,
  Pagination,
} from '../../components';
import { getVehiclesToService } from '../../redux/actions/vehicles';

interface Props {
  goBack: () => void;
  goTo: (path: string) => void;
  getVehiclesToService: (
    page: number,
  ) => Promise<{
    vehicles: IVehicle[];
    lastPage: boolean;
  }>;
}

interface State {
  isFetching: boolean;
  vehicles: IVehicle[];
  lastPage: boolean;
  page: number;
}

class Route extends React.Component<Props, State> {
  state = {
    isFetching: true,
    vehicles: [],
    lastPage: false,
    page: 0,
  };

  async componentDidMount() {
    this.getPage(this.state.page);
  }

  getPage = async (page: number) => {
    this.setState({ isFetching: true });
    const { vehicles, lastPage } = await this.props.getVehiclesToService(page);
    this.setState({
      page,
      vehicles,
      lastPage,
      isFetching: false,
    });
  };

  render() {
    return (
      <RouteWrapper
        title="Service"
        requireAuth
        requirePermission="MANAGE_SERVICE"
      >
        <HeadingSection
          title="Vehicles to Service"
          controls={[
            <IconButton
              icon="lock"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.goTo('/service/history');
              }}
              key="history"
            >
              History
            </IconButton>,
            <IconButton
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.goBack();
              }}
              key="return"
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <ServicingTable
            loading={this.state.isFetching}
            vehicles={this.state.vehicles}
            onClick={(vehicle) => this.props.goTo(`/service/${vehicle.id}`)}
          />
          <Pagination
            page={this.state.page}
            lastPage={this.state.lastPage}
            handleUpdate={(page) => {
              this.getPage(page);
            }}
          />
        </Section>
      </RouteWrapper>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  goTo: (path: string) => dispatch(push(path)),
  goBack: () => dispatch(goBack()),
  getVehiclesToService: (page: number) => dispatch(getVehiclesToService(page)),
});

export default connect(undefined, mapDispatchToProps)(Route);
